module.exports = __webpack_public_path__ + "img/zuanjie1-1.f76068b7.jpg";